import React from 'react';

import { MarkerTypes } from '../types';
import { svgToUri } from '../utils';

import { destinationMarkerSvg } from './destination-marker.web';
import { driverMarkerSvg } from './driver-marker.web';
import { storeActiveMarkerSvgRevamp } from './store-marker-active.web';
import { storeDisabledMarkerSvgRevamp } from './store-marker-disabled.web';
import { storeFavoriteClosedMarkerSvgRevamp } from './store-marker-fav-closed.web';
import { storeFavoriteMarkerSvgRevamp } from './store-marker-fav.web';
import { storeMarkerSvgRevamp } from './store-marker.web';
import { storeSelectedInactiveRevamp } from './store-selected-inactive';
import { userMarkerSvg } from './user-marker.web';

const markersUrisRevamp = {
  [MarkerTypes.User]: svgToUri(userMarkerSvg),
  [MarkerTypes.UserManual]: null,
  [MarkerTypes.StoreOpen]: svgToUri(storeMarkerSvgRevamp),
  [MarkerTypes.StoreOpenSelected]: svgToUri(storeMarkerSvgRevamp),
  [MarkerTypes.StoreFocused]: svgToUri(storeActiveMarkerSvgRevamp),
  [MarkerTypes.StoreFocusedSelected]: svgToUri(storeActiveMarkerSvgRevamp),
  [MarkerTypes.StoreNotAvailable]: svgToUri(storeDisabledMarkerSvgRevamp),
  [MarkerTypes.StoreFavOpen]: svgToUri(storeFavoriteMarkerSvgRevamp),
  [MarkerTypes.StoreFavSelected]: svgToUri(storeFavoriteMarkerSvgRevamp),
  [MarkerTypes.StoreFavNotAvailable]: svgToUri(storeFavoriteClosedMarkerSvgRevamp),
  [MarkerTypes.Destination]: svgToUri(destinationMarkerSvg),
  [MarkerTypes.Driver]: svgToUri(driverMarkerSvg),
  [MarkerTypes.StoreFocusedNotAvailable]: svgToUri(storeSelectedInactiveRevamp),
};

export const deriveMarkerIconRevamp = (type: MarkerTypes): React.ReactNode | string => {
  const icon = markersUrisRevamp[type];
  if (!icon) {
    throw new Error(`Unsupported type: ${type}`);
  }
  return icon;
};
